import React from 'react';
import { connect } from 'react-redux';
import SlotPicker from '../../common/Subscription/SlotPicker';
import WeekView from '../../common/Subscription/WeekView';
import SubscriptionItems from '../../common/Subscription/SubscriptionItems';
import Button from '../../common/Button/Button';
import {
  getCalendar,
  getSummary,
} from 'hb-redux-store/feature/subscription/subscription.action';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import { setAppNotification } from 'hb-redux-store/initial.action';
import {
  setSubscriptionSummaryModal,
  showLoginModal,
} from 'hb-redux-store/feature/modal/modal.action';
import { getSubscriptionRoute } from './subscription.routes';
import SubscriptionSummary from './SubscriptionSummary';
import Icon from '../../mweb/Icon/Icon';
import ProductMarque from '../../common/Subscription/ProductMarque';
import history from 'hb-redux-store/history';
import { Helmet } from 'react-helmet';

class RamadanSubscription extends React.Component {
  componentDidMount() {
    this.props.getCalendar();
    if (
      this.props.match?.path === getSubscriptionRoute('subscriptionSummary')
    ) {
      this.props.setSubscriptionSummaryModal(true);
    }
  }

  render() {
    const {
      loading,
      calendar,
      launchInfo,
      setSubscriptionSummaryModal,
    } = this.props;
    const isLoggedInUser = launchInfo.loggedIn;
    const { finalPrice = 0, strikedPrice = 0 } = calendar || {};
    const seo = {
      title:
        'Celebrate this Ramadan with fresh chicken & meat from Halalbox | Fresh Early Morning Delivery',
      description:
        'Celebrate this Ramadan with fresh chicken & meat from Halalbox | Fresh Early Morning Delivery',
      keywords:
        'Ramadan, Fresh Chicken, Fresh Mutton, Fresh Early Morning Delivery, Halalbox',
      canonical: 'https://www.halalbox.in/ramadan-subscription',
      image:
        'https://ik.imagekit.io/iwcam3r8ka/custom-tiles/202103/f2497f5a-c119-4185-baa9-c3e116c0ef10.png',
    };
    return (
      <React.Fragment>
        <Helmet>
          <title>{seo.title}</title>
          <meta name="description" content={seo.description} />
          <meta name="keywords" content={seo.keywords} />
          <link rel="canonical" href={seo.canonical} />
          {/*  Twitter Card data  */}
          <meta name="twitter:card" value={seo.description} />
          {/*  Open Graph data  */}
          <meta property="og:title" content={seo.title} />
          <meta property="og:image" content={seo.image} />
          <meta property="og:description" content={seo.description} />
        </Helmet>
        <div className="subsc">
          <div className="subsc--banner">
            <div className="subsc--banner--half">
              <img
                className="subsc--banner--info-banner"
                src="https://ik.imagekit.io/iwcam3r8ka/prod/subscription/202104/a1c68905-1932-445e-982a-a6c174c6686c.png"
                alt="Ramadan Special"
              />
            </div>
            <div className="subsc--banner--half">
              <ProductMarque />
            </div>
          </div>
          {loading && <Loader />}
          {calendar && (
            <React.Fragment>
              <div className="subsc--slots-container">
                <SlotPicker />
                <WeekView />
              </div>

              <div className="subsc--items-container">
                <div className="subsc--summary-unit justify-content--space-between">
                  <div className="subsc--summary-unit--pricing flex-align-items-center">
                    <Icon class="icon-subscription-cart" size={22} />
                    {strikedPrice > finalPrice && (
                      <span className="striked">{`₹${strikedPrice}`}</span>
                    )}
                    <span className="final">{`₹${finalPrice}`}</span>
                  </div>
                  <div>
                    <Button
                      type="submit"
                      className="button button-secondary"
                      onClick={() => {
                        const { selectedSlot } = this.props;
                        if (!isLoggedInUser) {
                          this.props.showLoginModal(true);
                          return history.replace(
                            '/ramadan-subscription?redirectUrl=ramadan-subscription'
                          );
                          // return this.props.setAppNotification(
                          //   'Please login to subscribe.'
                          // );
                        }
                        if (calendar.subscriptionId) {
                          if (!selectedSlot) {
                            return this.props.setAppNotification(
                              'Please choose delivery slot.'
                            );
                          }
                          if (!finalPrice > 0) {
                            return this.props.setAppNotification(
                              'Please selected products for atleast one day.'
                            );
                          }
                          setSubscriptionSummaryModal(true);
                          this.props.getSummary({
                            subscriptionNo: calendar.subscriptionId,
                          });
                        }
                      }}
                      disabled={loading}
                    >
                      {isLoggedInUser ? 'View Summary' : 'Login To Subscribe'}
                    </Button>
                  </div>
                </div>
                <SubscriptionItems />
              </div>
            </React.Fragment>
          )}
        </div>
        <SubscriptionSummary />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ subscriptionReducer, initialReducer }) => ({
  loading: subscriptionReducer.loading,
  calendar: subscriptionReducer.calendar,
  selectedSlot: subscriptionReducer.selectedSlot,
  summary: subscriptionReducer.summary,
  subscriptionItems: subscriptionReducer.subscriptionItems,
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  getCalendar,
  setAppNotification,
  setSubscriptionSummaryModal,
  getSummary,
  showLoginModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RamadanSubscription);
